'use client';

import React, { type ReactElement } from 'react';

import { selectIsTenant, useDomainStore } from '@/store/use-domain.store';
import { isDesktop } from 'react-device-detect';

import Drawer from '@/common/components/drawer';
import { PopUpModal } from '@/common/components/modal/popupModal.component';

import CustomerSupportDrawerContent from './customer-support-drawer-content.component';

interface Props {
  openSupport: boolean;
  handleToggle: () => void;
  title: string;
  description?: string;
  hasWitroMagLink?: boolean;
}

export default function CustomerSupportDrawer({
  handleToggle,
  openSupport,
  title,
  description,
  hasWitroMagLink,
}: Props): ReactElement {
  const isTenant = useDomainStore(selectIsTenant);
  if (isDesktop) {
    return (
      <PopUpModal
        onCancel={handleToggle}
        open={openSupport}
        width={360}
        classNames={{ content: 'support-modal-content' }}
      >
        <PopUpModal.Body>
          <CustomerSupportDrawerContent
            description={description}
            handleToggle={handleToggle}
            title={title}
            hasWitroMagLink={hasWitroMagLink}
            isTenant={isTenant}
          />
        </PopUpModal.Body>
      </PopUpModal>
    );
  }
  return (
    <Drawer
      placement="bottom"
      height={'auto'}
      open={openSupport}
      onClose={handleToggle}
      className="rounded-t-2xl pb-2"
    >
      <CustomerSupportDrawerContent
        description={description}
        handleToggle={handleToggle}
        title={title}
        hasWitroMagLink={hasWitroMagLink}
        isTenant={isTenant}
      />
    </Drawer>
  );
}
